import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getReciclar(accion, valor) {
  var nuevo_valor = '&reciclar=' + valor;
  var usuario = '&usuarioOk=' + getCookie('usuarioOk');
  var params =
    '?folioPedido=' + getCookie('folioPedido') + '&accion=' + accion + nuevo_valor + usuario;
  const url = `${webservice}/getReciclar${params}`;
  let response = '';

  await superagent
    .get(url)
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .set('Content-Type', 'application/json')
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
    });

  return response;
}
